<template>
    <div :style="{width, height}" class="statisDiv">
        <div class="totalDivClass">
            <div class="totalClass">{{totalText}}</div>
            <div class="companyClass">{{companyName}}</div>
        </div>
        <div class="describeClass">{{describeText}}</div>
    </div>
</template>

<script>
export default {
    props: {
        width: String,
        height: String,
        totalText: String,
        companyName: String,
        describeText: String
    },
    data(){
        return{

        }
    }
}
</script>

<style lang="scss" scoped>
.statisDiv{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background-image: url('../src/assets/imgs/mobile_circle.png');
    background-size: 100% 100%;
    // background-color: aquamarine;
}
.totalDivClass{
    margin-top: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    // background-color: #FFFFFF;
}
.totalClass{
    font-weight: 600;
    font-size: 24px;
    color: #13FFEE;
    // background-color: #6dc6e9;
    height: 30px;
    line-height: 40px;
}
.companyClass{
    font-weight: 600;
    font-size: 14px;
    color: #13FFEE;
    height: 5px;
    line-height: 20px;
}
.describeClass{
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 600;
}
</style>